module.exports = require("react-window");